import { Link, useLocation } from "react-router-dom";
import Icon from "@/components/base/Icon";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-8 py-24 flex flex-col items-center text-center">
      <span className="w-16 h-16 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
        <Icon name="ri-emotion-sad-line" className="w-8 h-8" />
      </span>
      <p className="mt-6 font-heading text-5xl md:text-6xl font-bold text-primary-500">404</p>
      <h1 className="mt-4 font-heading text-xl md:text-2xl font-semibold text-foreground-950">
        这一页走丢了
      </h1>
      <p className="mt-2 text-sm text-foreground-500 break-all">
        找不到页面：{location.pathname}
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
        >
          <Icon name="ri-home-4-line" className="w-4 h-4" />
          返回首页
        </Link>
        <Link
          to="/category/all"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <Icon name="ri-compass-3-line" className="w-4 h-4" />
          浏览全部漫画
        </Link>
      </div>
    </div>
  );
}